var exports = {
  "kL": "MultiCharacterHeads.module__container___RUo1UU",
  "V2": "MultiCharacterHeads.module__pair___RUo1UU",
  "KI": "MultiCharacterHeads.module__avatarButton___RUo1UU",
  "my": "MultiCharacterHeads.module__avatar___RUo1UU",
  "UU": "MultiCharacterHeads.module__name___RUo1UU",
  "vE": "MultiCharacterHeads.module__timestamp___RUo1UU",
};

module.exports = exports;
